import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './client';

/** TanStack Query defaults: no retry on 4xx (permission/validation answers are final), short freshness, no refetch on focus. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (count, err) => !(isApiError(err) && err.status >= 400 && err.status < 500) && count < 2,
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  });
}
